export const FAQ = ({ q, a }: { q: string; a: string }) => (
    <div className="faq-item">
      <strong>{q}</strong>
      <p>{a}</p>
    </div>
  );